// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7v6eF","question":"styles_question__KD3NF","description":"styles_description__16dRQ"};